import { render } from "./MediaList.vue?vue&type=template&id=bc967558&scoped=true"
import script from "./MediaList.vue?vue&type=script&lang=js"
export * from "./MediaList.vue?vue&type=script&lang=js"

import "./MediaList.vue?vue&type=style&index=0&id=bc967558&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc967558"]])

export default __exports__